import { Directive, EventEmitter, Input, Output } from '@angular/core';

export interface PackageCardOption {
  id: string;
  label: string;
  description?: string;
  priceLabel: string;
  originalPriceLabel?: string;
  note?: string;
  family_plan?: boolean;
  type?: 'single' | 'monthly';
}

@Directive()
export abstract class BasePackageCardDirective {
  @Input() title = '';
  @Input() features: string[] = [];
  @Input() options: PackageCardOption[] = [];
  @Input() selectedOptionId: string | null = null;
  @Output() selectionChange = new EventEmitter<string>();

  onSelect(optionId: string): void {
    this.selectedOptionId = optionId;
    this.selectionChange.emit(optionId);
  }

  trackByFeature(_: number, feature: string): string { return feature; }
  trackByOption(_: number, option: PackageCardOption): string { return option.id; }

  getDescriptionParts(desc?: string): { left: string; right: string } | null {
    if (!desc) return null;
    const parts = desc.split('•');
    if (parts.length < 2) {
      return { left: desc, right: '' };
    }
    return { left: parts[0].trim(), right: parts.slice(1).join('•').trim() };
  }
}
